<template>
  <div class="loading-container">
    <div class="loading-spinner"></div>
    <p class="loading-text">Loading instructors...</p>
  </div>
</template>

<script>
export default {
  name: 'LoadingState'
};
</script>

<style scoped>
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  background: var(--bg-white);
  border-radius: var(--radius-lg);
  margin: 2rem 0;
  box-shadow: var(--shadow-lg);
}

.loading-spinner {
  width: 36px;
  height: 36px;
  border: 4px solid var(--primary-light);
  border-top: 4px solid var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 0.7rem;
}

.loading-text {
  color: var(--text-medium);
  font-size: 1rem;
  margin: 0;
  font-weight: 500;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style> 